import React, { FC } from "react";
import { Modal, Button } from "antd";
import { AccruedFee } from "../../data-types";
import styles from "./report-modal.module.css";
import { ReportPreview } from "./report-preview";

const { ["modal"]: modalClassName } = styles as any;

export type MatterReportModalProps = {
  show: boolean;
  matterId: number;
  accruedFee?: AccruedFee;
  onClose: () => void;
};

export const MatterReportModal: FC<MatterReportModalProps> = ({
  show,
  matterId,
  accruedFee,
  onClose,
}) => {
  if (!accruedFee || !matterId) {
    return null;
  }

  return (
    <Modal
      className={modalClassName}
      style={{ top: 25 }}
      width="1000px"
      open={show}
      maskClosable={false}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <ReportPreview matterId={matterId} />
    </Modal>
  );
};
